import { CurrentLang } from '@shared/localizations/Resources';
import { CustomInstrumentList } from './CustomInstrumentList';
export class CustomInstrumentListsCache {
    constructor() {
        this.instrumentListsDict = new Map();
    }
    addOrUpdate(mess) {
        const instrumentList = this.instrumentListsDict.get(mess.Id);
        if (isNullOrUndefined(instrumentList)) {
            this.instrumentListsDict.set(mess.Id, new CustomInstrumentList(mess));
        }
        else {
            instrumentList.Update(mess);
        }
    }
    getInstrumentIndustry(instrument) {
        const oldIndustry = instrument.Industry;
        return this.getLocalizedInstrListName(oldIndustry, instrument.IndustryCustomListId);
    }
    getInstrumentSector(instrument) {
        const oldSector = instrument.Sector;
        return this.getLocalizedInstrListName(oldSector, instrument.SectorCustomListId);
    }
    clear() {
        this.instrumentListsDict.clear();
    }
    getCustomListsByType(type) {
        const arrCustomListsDict = [];
        this.instrumentListsDict.forEach((customList) => {
            if (customList.type === type) {
                arrCustomListsDict.push(customList);
            }
        });
        return arrCustomListsDict;
    }
    getLocalizedListName(listId) {
        var _a, _b;
        const instrumentList = this.instrumentListsDict.get(listId);
        if (isNullOrUndefined(instrumentList)) {
            return null;
        }
        if (!isNullOrUndefined(instrumentList.langAliases)) {
            return (_b = (_a = instrumentList.langAliases[CurrentLang]) === null || _a === void 0 ? void 0 : _a.Name) !== null && _b !== void 0 ? _b : instrumentList.name;
        }
        return instrumentList.name;
    }
    getLocalizedInstrListName(listName, listId) {
        const localizedListName = this.getLocalizedListName(listId);
        if (isValidString(localizedListName)) {
            return localizedListName;
        }
        return listName;
    }
}
